export default {
  labels: {
    order: 'Comandă',
    customer: 'Client',
  },
  tags: {
    new_customer: 'Client nou',
    loyal_customer: 'Client fidel',
  },
};
